import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const OnDemandTutoring = lazyRouteComponent(() => import('@/_instructor/on-demand-tutoring'));

export const Route = createFileRoute('/_instructor/on-demand-tutoring/')({
  component: () => renderInstructorPage(OnDemandTutoring),
});
